import React from 'react';
import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import getExplicitlyLicensedProducts from '@atlassian/jira-common-get-explicitly-licensed-products/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { PACKAGE_NAME, ANALYTIC_SOURCE } from './constants.tsx';
import type { UpgradeEditionMenuItemProps } from './types.tsx';
import { shouldRenderMenuItem, getActivePageApplicationKey } from './utils.tsx';
import RenderUpgradeMenuItem from './render-upgrade-menu-item/index.tsx';

const UpgradeEditionMenuItemOld = ({ setUpgradeEditionMenuShown }: UpgradeEditionMenuItemProps) => {
	const tenantContext = useTenantContext();
	const { data: projectData, loading: projectDataLoading } = useProject();

	if (projectDataLoading) {
		return null;
	}

	const { isSiteAdmin } = tenantContext;
	const explicitlyLicensedProducts = getExplicitlyLicensedProducts(tenantContext);
	const applicationKey = getActivePageApplicationKey(
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		projectData?.type as ProjectType | undefined,
		explicitlyLicensedProducts,
	);

	if (
		!shouldRenderMenuItem(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext)
	) {
		setUpgradeEditionMenuShown(false);
		return null;
	}

	// Add separator bar in the menu
	setUpgradeEditionMenuShown(true);

	return (
		<JSErrorBoundary id={ANALYTIC_SOURCE} packageName={PACKAGE_NAME} fallback="unmount">
			<RenderUpgradeMenuItem product={applicationKey} />
		</JSErrorBoundary>
	);
};

export default UpgradeEditionMenuItemOld;
